const changeOrderStatus = {
  concept: 'CONCEPT',
  submitted: 'SUBMITTED',
  archived: 'ARCHIVED',
}
export default changeOrderStatus
